export const REWARD_HASH_KEY = 'reward_hash';
export const SESSION_ID_KEY = '_sp_id.3c2b';
